import { useMutation, useQuery } from "@tanstack/react-query";
import {
  albumRequests,
  BlogList,
  cancelInterest,
  // contactRequests,
  interestRequests,
  LatestProfiles,
  markFavourite,
  marknoInterested,
  messageRequest,
  PremiumMatches,
  ProfileCompletion,
  RecommendedProfiles,
  reqContact,
  requestAlbum,
  sendInterest,
  SuccessStories,
} from "api/home";
import AlertNotification from "components/CustomWidgets/alertNotification";

export const usePremiumMatches = (
  { page, limit, see_all, filter_data },
  options = {},
) => {
  return useQuery({
    queryKey: ["premiumMatches", { page, limit, see_all, filter_data }],
    queryFn: PremiumMatches,
    ...options,
  });
};

export const useProfileCompletion = (options = {}) => {
  return useQuery({
    queryKey: ["profile-completion"],
    queryFn: ProfileCompletion,
    ...options,
  });
};

export const useBlogList = (
  { see_all, request_type, exclude_id, search_key },
  options = {},
) => {
  return useQuery({
    queryKey: ["blog-list", { see_all, request_type, exclude_id, search_key }],
    queryFn: BlogList,
    ...options,
  });
};

export const useSuccessStories = (
  { page, limit, see_all = false, id, search_key },
  options = {},
) => {
  return useQuery({
    queryKey: ["success-stories", { page, limit, see_all, id, search_key }],
    queryFn: SuccessStories,
    ...options,
  });
};

export const useRequestAlbum = (options = {}) => {
  return useMutation({
    mutationFn: requestAlbum,
    onSuccess: (data, variables, context) => {
      AlertNotification("success", `Image request sent to ${variables.name}`);
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useContactRequest = (options = {}) => {
  return useMutation({
    mutationFn: reqContact,
    onSuccess: (data, variables, context) => {
      AlertNotification("success", data.message);
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useSendInterest = (options = {}) => {
  return useMutation({
    mutationFn: sendInterest,
    onSuccess: (data, variables, context) => {
      AlertNotification("success", data.message);
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useMessageRequest = (options = {}) => {
  return useMutation({
    mutationFn: messageRequest,
    onSuccess: (data, variables, context) => {
      AlertNotification("success", data.message);
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useCancelInterest = (options = {}) => {
  return useMutation({
    mutationFn: cancelInterest,
    onSuccess: (data, variables, context) => {
      AlertNotification("success", data.message);
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useMarkNoInterested = (options = {}) => {
  return useMutation({
    mutationFn: marknoInterested,
    onSuccess: (data, variables, context) => {
      AlertNotification("success", data.message);
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useMarkFavourite = (options = {}) => {
  return useMutation({
    mutationFn: markFavourite,
    onSuccess: (data, variables, context) => {
      AlertNotification("success", data.message);
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useRecommendedProfiles = (
  { page, limit, see_all, filter_data },
  options = {},
) => {
  return useQuery({
    queryKey: ["recommendedProfiles", { page, limit, see_all, filter_data }],
    queryFn: RecommendedProfiles,
    ...options,
  });
};

export const useLatestProfile = (
  { page, limit, see_all, filter_data },
  options = {},
) => {
  return useQuery({
    queryKey: ["latestProfiles", { page, limit, see_all, filter_data }],
    queryFn: LatestProfiles,
    ...options,
  });
};

// export const useContactRequestHandler = (options = {}) => {
//   return useMutation({
//     mutationFn: contactRequests,
//     onSuccess: (data, variables, context) => {
//       AlertNotification("success", data.message);
//       options.onSuccess?.(data, variables, context);
//     },
//   });
// };

export const useAlbumRequestHandler = (options = {}) => {
  return useMutation({
    mutationFn: albumRequests,
    onSuccess: (data, variables, context) => {
      AlertNotification("success", data.message);
      options.onSuccess?.(data, variables, context);
    },
  });
};

export const useInterestRequestHandler = (options = {}) => {
  return useMutation({
    mutationFn: interestRequests,
    onSuccess: (data, variables, context) => {
      AlertNotification("success", data.message);
      options.onSuccess?.(data, variables, context);
    },
  });
};
